






import Vue from 'vue';

export default Vue.extend({
  name: "ThemeParkMain2d",
  data: () => {
    return {};
  },
});
